<template>
  <div class="" :class="['top animated fadeInDown',state==1?'blue-top':'',scrollClass,searchBool?'search-show':'search-hide']">
    <div class="top-menu" :class="[state==2?'top-menu-state2':'']">
      <div class="top-tabs">
        <div class="swiper-container container-top">
          <div class="swiper-wrapper">
            <template v-if="lists&&lists.length">
              <div class="swiper-slide" :class="[(parameter.typeId==0?'active':'')]" :key="'top-1'">
                <div :key="'top-1'" @click="tabClick(0)">
                  <p>首页</p>
                </div>
              </div>
              <template v-for="(list,index) in lists">
                <div v-if="parameter.cityId!=1||parameter.cityId==1&&(list.id==3||list.id==10||list.id==7)" class="swiper-slide" :class="[(parameter.typeId==list.id?'active':'')]" :key="'top'+index">
                  <div :key="'top'+index" @click="tabClick(list.id)">
                    <p>{{list.name}}</p>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
      <div class="search-map">
        <div class="search-all">
          <div class="search-btn posRe" @click="searchBtn"><i class="icon-img icon-search"></i>搜索</div>
          <div class="search-address" :class="[selectAddress]" v-if="state==2" @mouseleave="leaveFun">
            <div class="search-address-name oneRow" @mouseover="addressFun"  @click="addressShowHide">{{addressCity.name || '区域选择'}}<i class="icon-img"></i></div>
            <!--<address></address>-->
            <div class="search-address-list">
              <div class="search-address-list-center">
                <ul :class="addressSearchClass">
                  <template v-if="addressBtn&&addressBtn.length" v-for="(item, index) in addressBtn">
                    <li :key="'item'+index" :class="[tabIndex==index?'active':'']" @click="tabAddress(index)">
                      <div class="oneRow">{{item}}</div>
                    </li>
                  </template>
                  <li>
                    <div class="address-search">
                      <span class="icon-img icon-search" @click="addressSearch"></span>
                      <div class="address-search-input"
                           @mouseenter="searchEnter"
                           @mouseleave="searchLeave">
                        <input type="text"
                               v-model="addressVal"
                               placeholder="请输入地名"
                               @input="searchInput"
                               @compositionstart="compositionstart"
                               @compositionend="compositionend"
                        />
                        <span class="icon-img icon-search-close" @click="searchClose"></span>
                        <template v-if="addressVal&&addressListBool">
                          <div class="address-search-input-list">
                            <div class="max-con">
                              <template v-if="addressSearchList&&addressSearchList.length">
                                <template v-for="(list,index) in addressSearchList">
                                  <div class="oneRow address-search-input-list-one"
                                       @click="addressMapTo(list)"
                                       :key="'addressSearchList'+index">{{list.name}}</div>
                                </template>
                              </template>
                              <template v-else>
                                <div>暂无相关内容</div>
                              </template>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <span  class="jump-home" @click="tabClick(-1)">{{$realmNameId==50?'重庆':'四川'}}</span>
                  </li>
                </ul>
                <div class="address-content">
                  <div v-if="tabIndex==0">
                    <template v-if="cityData&&cityData.length">
                      <template v-for="(city, i) in cityData">
                          <!--<span>{{city.letter}}</span>-->
                        <div class="oneRow"
                             @click="cityTo(city)"
                             :title="city.name"
                             :key="'addressIndex'+ i"
                             :class="[cityActiveId==city.cityId?'active':'',city.state?'':'no-click']">{{city.name}}</div>
                         <!-- <template v-if="city.data&&city.data.length">
                            <template v-for="(item,itemIndex) in city.data">
                            </template>
                          </template>-->
                      </template>
                    </template>
                  </div>
                  <div v-if="tabIndex==1">
                    <template v-if="countyData&&countyData.length">
                      <template v-for="(county, i) in countyData">
                        <!--<div :key="'addressIndex'+ i">-->
                          <!--1254{{county.name}}-->
                          <!--<span>{{county.letter}}</span>-->
                        <div @click="countyTo(county)"
                             class="oneRow"
                             :title="county.name"
                             :class="[county.cityId==cityActiveId?'active':'',county.state?'':'no-click']"
                             :key="'addressLetterIndex'+i">{{county.name}}</div>
                          <!--<template v-if="county.data&&county.data.length">
                            <template v-for="(item,itemIndex) in county.data">
                            </template>
                          </template>-->
                        <!--</div>-->
                      </template>
                    </template>
                    <template v-else>
                      <div>暂无</div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="map-btn" @click="mapMap"><i class="icon-img icon-map"></i>进入地图</div>

        <div class="qr-code-btn" v-if="$realmNameId==51">
          <el-popover
            width="130"
            popper-class="el-popper-code"
            trigger="hover">
            <template>
              <vue-qr :logoMargin="5" draggable="false" :logoSrc="qrLogoSrc" :logoScale="0.2" :logoBackgroundColor="'white'" :text="url" :marign="8" :size="800"></vue-qr>
             <!-- <div class="qr-code-content-list clearFloat clearFloat-2-3">
                <div>
                  <vue-qr :logoMargin="5" draggable="false" :logoSrc="qrLogoSrc" :logoScale="0.3" :logoBackgroundColor="'white'" :text="url" :marign="20" :size="800"></vue-qr>
                  <p>手机访问</p>
                </div>
                <div>
                  <div><img src="static/images/app_code.png" alt="" draggable="false"></div>
                  <p>APP下载</p>
                </div>
              </div>-->
              <i slot="reference" class="icon-img icon-qr-code" @click="seeClickQrCode"></i>
            </template>
          </el-popover>
        </div>

      </div>
    </div>
    <search @searchBoolBtn="searchBoolBtn" :state="state" :parameter="parameter"></search>
  </div>
</template>

<script>
import search from '@/components/search'
import vueQr from 'vue-qr'

export default {
  props: ['state', 'searchKeyVal'],
  name: 'top',
  data () {
    return {
      lists: [],
      loaded: false,
      searchBool: false,
      addressCity: '',
      addressBtn: ['地级市', '区县级'],
      cityData: [],
      countyData: [],
      addressAllData: [],
      cityIndex: -1,
      selectAddress: '',
      parameter: {
        typeId: 0,
        cityId: 0,
        keyWords: '',
        cityIndex: -1,
        countyIndex: -1,
        topIndex: -1
      },
      tabIndex: 0,
      cityActiveId: -1,
      topIndexState: 0,
      scrollClass: '',
      addressVal: '',
      addressSearchClass: '',
      addressListBool: false,
      addressSearchList: [],
      flag: true,
      addressShowHideBool: true,
      containerTop: '',
      url:'',
      qrImgUrl:'',
      qrLogoSrc:'static/images/1024.png',
//      qrLogoSrc:'',
      isSeeQr:false
    }
  },
  created () {
    let _that = this;
    let parameter = JSON.parse(_that.publicJs.decode(_that.$route.query)) || {};

    if(_that.$realmNameId==50){
      _that.addressBtn=['区县', '乡镇']
    }else {
      _that.addressBtn=['地级市', '区县级']
    }
    _that.parameter.cityId = parameter.cityId||0;
    _that.parameter.typeId = parameter.typeId||0;
    _that.parameter.keyWords = parameter.keyWords;
    _that.cityActiveId = parameter.cityId ||0;
    _that.parameter.topIndex = parameter.topIndex >= 0 ? parameter.topIndex : -1;


    let k={
      cityId: (parameter.cityId||0),
      typeId: 0,
      topIndex: -1
    };

    _that.url='http://pano.szscmap.com/App/meiLiSiChuan/'+(k.cityId?('?key='+(_that.publicJs.encode(JSON.stringify(k)))):'');
    this.httpData();
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    let that =this;

   /* var Url=that.publicJs.getUrlCookie('Url')||'';
   that.httpAjax.getAjax('CityWebService.asmX/GetSiteInfoByCity', {cityId: that.parameter.cityId||0}).then(function (res) {
      if (res.code === 1) {
        let data = res.data && res.data.length ? JSON.parse(JSON.stringify(res.data[0])) : {};
        let qrImg=data.qrImg||'',
          qrLogo=data.qrLogo||'';
        if(qrImg){
          that.qrImgUrl=qrImg
        }else {
    that.url='http://pano.szscmap.com/App/meiLiSiChuan/'+Url?Url:window.location.href;
        }
      }
    }, function (err) {
      console.log(err)
    })*/

  },
  components: {
    search: search,
    vueQr:vueQr
  },
  methods: {
    handleScroll: function () { // 页面滚动一定的位置
      let that = this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 150) {
        if (!that.scrollClass) that.scrollClass = 'scroll-top'
      } else {
        that.scrollClass = ''
      }
    },
    tabClick: function (typeId) { // 职业点击事件 index:下标  typeId:职业的id
      let _that = this;
      _that.parameter.typeId = typeId;
      _that.parameter.keyWords = _that.searchKeyVal;
      _that.searchBool = false;
      let index=(_that.publicJs.onlyTypeData(_that.lists,typeId)).index;
      this.containerTop.slideTo(index >= 0 ? index : -1);
      let b = JSON.parse(_that.publicJs.decode(_that.$route.query));
      if (_that.state === 0 || _that.state === 1) {
        _that.topIndexState = 0
      } else {
        _that.topIndexState = 1
      }
      if (index >=0) { // 下标大于0 跳转搜索展示页面
        let data = {
          path: '/searchPage',
          query: {
            key: _that.publicJs.encode(JSON.stringify({
              typeId: typeId,
              keyWords: _that.parameter.keyWords,
              cityId: _that.parameter && _that.parameter.cityId ? _that.parameter.cityId : 0,
            })),
            '_': new Date().getTime()
          }
        }
        this.$router.push(data)
      } else { // 下标等于0 跳转搜索城市页面或者首页
        let currentParams = JSON.parse(this.publicJs.decode(_that.$route.query))
        if (currentParams.cityId && typeId >= 0) { // 获取连接cityId 有值跳转到城市页面 并且typeId=>0
          let c = _that.$router.resolve({
            path: '/pageCity',
            query: {
              key: _that.publicJs.encode(JSON.stringify({
                cityId: currentParams.cityId,
                typeId: 0,
                topIndex: -1,
              })),
              '_': new Date().getTime()
            }
          })
          window.open(c.href, '_pageCity' + currentParams.cityId)
        } else { // 获取连接无cityId 有值跳转到四川首页 并且typeId == -1
          if (b.cityId) {
            let c = _that.$router.resolve({
              path: '/'
            });
            window.open(c.href, '_pageHome')
          } else {
            this.$router.push('/')
          }
        }
      }
    },
    httpData: function () { // 获取职业数据
      let _that = this;
      _that.publicJs.navGetData(function (data) {
        if (data.code === 1) {
          _that.lists = _that.lists.concat(data.data);
          _that.$nextTick(function () {
            _that.swiperFun()
          })
        }
      })
    },
    swiperFun: function () { // 职业轮播
      let _that = this;
      _that.$nextTick(function () {
        // eslint-disable-next-line
        _that.containerTop = new Swiper('.container-top', {
          slidesPerView: 'auto',
          spaceBetween: 84,
          observer: true,
          observeSlideChildren: true,
          observeParents: true,
          breakpoints: {
            1380: {
              spaceBetween: 60
            },
            1100: {
              spaceBetween: 50
            },
            900: {
              spaceBetween: 40
            },
            800: {
              spaceBetween: 30
            },
            750: {
              spaceBetween: 20
            }
          }
        })
      })
    },
    searchBtn: function () {
      this.searchBool = !this.searchBool
    },
    searchBoolBtn: function (val) {
      this.searchBool = val
    },
    addressAllDataFun: function () {
      let that = this;
      if (that.state === 2) {
        this.publicJs.addressGetData(function (res) {
          if (res.code === 1) {
            that.addressAllData =res.data;
            let addressData = that.publicJs.onlyCityData(res.data,that.cityActiveId);
            that.tabIndex = 1;
            that.addressCity = addressData || {cityId: 0, name: (that.$realmNameId==50?'重庆':'四川')};
            that.publicJs.changeDocumentTitle(that.addressCity.name,that.addressCity.cityId);
            that.cityData = res.data;
            that.countyData = (addressData.data?addressData.data||[]:(addressData.child||[]));
          }
        })
      }
    },
    addressShowHide: function () {
      let that = this;
      if (that.addressShowHideBool) {
        that.addressShowHideBool = false;
        that.addressFun()
      } else {
        that.addressShowHideBool = true;
        that.leaveFun()
      }
    },
    addressFun: function () {
      let that = this;
      that.selectAddress = 'address-active'
    },
    leaveFun: function () {
      let that = this;
      that.selectAddress = ''
    },
    countyTo: function (county) {
      if(!county.state){
        return false;
      }
      let that = this;
      let c = that.$router.resolve({
        path: '/pageCity',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            cityId: county.cityId,
            typeId: 0,
            topIndex: -1,
          })),
          '_': new Date().getTime()
        }
      })
      window.open(c.href, '_pageCity' + county.cityId)
    },
    tabAddress: function (i) {
      this.tabIndex = i
    },
    cityTo: function (city) {
      if(!city.state){
        return false;
      }
      let that = this;
      let routeQuery = JSON.parse(that.publicJs.decode(that.$route.query)) || {};
      that.tabIndex = 1;
      let c = that.$router.resolve({
        path: '/pageCity',
        query: {
          key: that.publicJs.encode(JSON.stringify({
            cityId: city.cityId,
            typeId: 0,
            topIndex: -1,
          })),
          '_': new Date().getTime()
        }
      })
      window.open(c.href, '_pageCity' + city.cityId)
    },
    mapMap: function () {
      // let cityId = this.parameter.cityId
      let data = {
        path: '/mapPage',
        query: {
          key: this.publicJs.encode(JSON.stringify({
            cityId: this.parameter.cityId,
            typeId: this.parameter.typeId,
            bool: true,
            state: this.state
          })),
          '_': new Date().getTime()
        }
      }
      this.$router.push(data)
    },
    addressSearch: function () {
      let that = this;
      that.addressSearchClass = 'address-search-active'
    },
    searchEnter: function () {
      this.addressListBool = true
    },
    searchLeave: function () {
      this.addressListBool = false
    },
    compositionstart: function () {
      this.flag = false
    },
    compositionend: function () {
      this.flag = true
    },
    searchInput: function () {
      let that = this;
      if (that.addressVal) {
        that.addressSearchList = that.publicJs.fuzzyQuery(that.addressAllData, that.addressVal)
      } else {
        that.addressSearchList = []
      }
    },
    searchClose: function () {
      this.addressSearchClass = ''
    },
    addressMapTo: function (onlyaddress) {
      let c = this.$router.resolve({
        path: '/pageCity',
        query: {
          key: this.publicJs.encode(JSON.stringify({
            cityId: onlyaddress.cityId,
            typeId: 0,
            topIndex: -1,
          })),
          '_': new Date().getTime()
        }
      })
      window.open(c.href, '_pageCity' + onlyaddress.cityId+Math.round(Math.random()*10))
    },
    seeClickQrCode:function(){ //查看城市二维码
      this.isSeeQr=!this.isSeeQr
    },
    mouseOver:function(){
      this.isSeeQr=true
    },
    mouseLeave:function () {
      this.isSeeQr=false
    }
  },
  watch: {
    state: function (a, b) {
      this.state = a
    },
    parameter: {
      handler: function (a, b) {
        this.addressAllDataFun()
      },
      deep: true
    },
    cityTopIndex: {
      handler: function (a, b) {
        if (a !== b) {
          this.parameter.cityIndex = a || 0;
          this.cityTopIndex = a
        }
      },
      deep: true
    },
    '$route': function (newData, b) {
      if (newData !== b) {
        let routeQuery = JSON.parse(this.publicJs.decode(newData.query));
        this.parameter.typeId = routeQuery.typeId || 0;
        this.cityActiveId = routeQuery.cityId || 0;
        this.parameter.keyWords = routeQuery.keyWords || '';
      }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .top{
    position: fixed;
    top:0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .top-menu{
    height: 60px;
    padding-left:73px;
    padding-right: 350px;
    position: relative;
    border-bottom: 2px solid rgba(255,255,255,0.5);
  }
  .top-menu-state2{
    padding-right: 420px;
  }
  .top-menu::after{
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 2px;
    background:rgba(0,0,0,0.2);
  }
  .blue-top .top-menu::after{
    background-color: #248DDF;
  }
  .scroll-top:not(.search-show) .top-menu::after{
    -webkit-transition: -webkit-transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    transition: -webkit-transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    -o-transition: transform .5s cubic-bezier(.165,.84,.44,1) 0s;
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    transform: scaleY(1);
    -webkit-transform-origin: top left;
    -ms-transform-origin: top left;
    transform-origin: top left;
    background-color: #248DDF;
    -webkit-animation: colorAnimate 0.5s;
    -o-animation: colorAnimate 0.5s;
    animation: colorAnimate 0.5s;
  }
  @keyframes colorAnimate {
    0%{
      -webkit-transform: scaleY(0);
      -ms-transform: scaleY(0);
      transform: scaleY(0);
    }
    100%{
      -webkit-transform: scaleY(1);
      -ms-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
  .search-show{
    background-color: #248DDF;
  }
  .search-show.scroll-top .top-menu::after{
    background:rgba(0,0,0,0.2);
  }
  .top-tabs{
    width: 100%;
    max-width: 991px;
    font-size: 18px;
    font-family:pingfang-refular;
    color: rgba(255,255,255,0.6);
    line-height: 1;
  }
  .swiper-slide{
    width: auto;
  }
  .swiper-slide>div{
    padding: 21px 0;
  }
  .top-tabs div.active{
    color: #ffffff;
    font-weight: bold;
    position: relative;
  }
  .top-tabs .swiper-slide>div::after{
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    height: 2px;
    background-color: white;
    -webkit-transition: all 0.8s;
    -moz-transition: all 0.8s;
    -ms-transition: all 0.8s;
    -o-transition: all 0.8s;
    transition: all 0.8s;
  }
  .top-tabs .swiper-slide.active>div::after{
    width: 36px;
    height: 2px;
    left:50%;
    margin-left: -18px;
    -webkit-animation: fadeInLeft 0.8s;
    -o-animation: fadeInLeft 0.8s;
    animation: fadeInLeft 0.8s;
  }
  .top-tabs .swiper-slide:hover>div{
    color: white;
  }
  .top-tabs .swiper-slide:hover>div::after{
    width: 100%;
    left: 0;
    margin-left: 0;
    -webkit-transition: width 0.5s;
    -moz-transition: width 0.5s;
    -ms-transition: width 0.5s;
    -o-transition: width 0.5s;
    transition: width 0.5s;
  }
  .search-map{
    position: absolute;
    right: 35px;
    top:10px;
    bottom: 8px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #fff;
    line-height: 1;
    letter-spacing: 1px;
    z-index: 88;
  }
  .search-map>div:last-child{
    border-right:none;
    margin-right: 0;
  }
  .search-map>div{
    position: relative;
  }
  .search-map i{
    position: absolute;
    top:50%;
    left: 0;
  }
  .search-all{
    border-right: 1px solid white;
    cursor: pointer;
    margin-right: 15px;
    display: flex;
    align-items: center;
    padding-right: 0;
  }
  .search-btn{
    position: relative;
    z-index: 3;
    padding: 10px 5px 10px 24px;
    margin-right: 5px;
  }
  .search-btn:hover,.map-btn:hover{
    opacity: 0.6;
    -webkit-transition: opactity 0.5s;
    -moz-transition: opactity 0.5s;
    -ms-transition: opactity 0.5s;
    -o-transition: opactity 0.5s;
    transition: opactity 0.5s;
  }



  .map-btn{
    cursor: pointer;
    border-right: 1px solid white;
    padding: 10px 20px 10px 47px;
    margin-right: 15px;
  }

  .search-btn .icon-search{
    width: 21px;
    height: 21px;
    background-position: -426px -230px;
    margin-top: -10px;
  }
  .map-btn .icon-map{
    width: 41px;
    height: 41px;
    background-position: -415px -300px;
    margin-top: -20px;
  }

  .qr-code-btn{
    display: block;
    width: 34px;
    height: 34px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .icon-qr-code{
    display: block;
    height: 34px;
    width: 34px;
    background-repeat:no-repeat;
    background-size: 95%;
    margin-top: -17px;
    -webkit-animation: jello 1s 2s infinite;
    -o-animation: jello 1s 2s infinite;
    animation: jello 1s 2s infinite;
    cursor: pointer;
  }

  .icon-qr-code:hover{
    -webkit-animation: none;
    -o-animation: none;
    animation: none;
  }

  .qr-code-content-list>div{
    width: 130px;
    float: left;
    text-align: center;

  }
  .qr-code-content-list img{
    height: 130px;

  }
  .qr-code-content-list p{
    font-size: 1rem;
    padding-top: 0.4rem;
    line-height: 1;
  }



  /*.qr-code-btn-yes .qr-code-content{
    display: block;
  }
  .qr-code-content>div{
    width:140px;
    height: 140px;
    padding: 5px;
    background-color: white;
    -webkit-box-shadow: 0 1px 3px 0 #55585b;
    -moz-box-shadow: 0 1px 3px 0 #55585b;
    box-shadow: 0 1px 3px 0 #55585b;
    border-radius: 5px;
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .qr-code-content-img>div{
    padding: 0;
  }
  .qr-code-content>div::after{
    content: '';
    position: absolute;
    top:-10px;
    left: 50%;
    margin-left: 10px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 10px solid white;
  }*/

  .search-address-name i{
    top: 50%;
    right: 6px;
    left: inherit;
  }
  .screen2 .search-map{
    right: 20px;
  }
  .screen3 .search-map{
    right: 10px;
  }
  .screen2 .search-all,.screen3 .search-all{
    margin-right: 10px;
    padding-right: 5px;
  }
  .screen2 .map-btn,
  .screen3 .map-btn{
    padding-right: 20px;
  }
  .screen3 .search-all{
    margin-right: 8px;
  }
  .screen3 .search-address-name {
    padding: 10px 28px 10px 5px;
  }
  .screen2 .search-btn,.screen3 .search-btn{
    z-index: 3;
    padding: 10px 5px 10px 24px;
    margin-right: 5px;
  }
  .screen3 .search-btn{
    margin-right: 0;
  }
  .screen2 .top-menu{
    padding-left: 20px;
    padding-right: 290px;
  }
  .screen2 .top-menu-state2{
    padding-right: 400px;
  }
  .screen3 .top-menu{
    padding-left: 20px;
    padding-right: 290px;
  }
  .screen3 .top-tabs div.active{
    font-weight: normal;
  }
  .screen2 .qr-code-content,
  .screen3 .qr-code-content{
    right: -15px;
  }
  .screen2 .qr-code-content>div:after,
  .screen3 .qr-code-content>div:after{
    margin-left: 27px;
  }

</style>



// WEBPACK FOOTER //
// src/components/top.vue